import AuthClient from "./AuthClient";
import queryString from "query-string";

const ChatApi = {
  getChatEnrollments: async (
    page,
    numResults,
    sortByOption,
    filters = {},
    cancelToken,
    isExport
  ) => {
    const params = {
      page,
      numResults,
      sortByOption,
      isExport,
      text: filters.keyword,
    };

    const response = await AuthClient.get(
      `Chat/chabadHouseEnrollments?${queryString.stringify(params)}`,
      { cancelToken },
    );
    return {
      enrollments: response.data.payload.results || [],
      totalEnrollments: response.data.payload.numberOfRows || 0,
    };
  },

  addChatEnrollment: async (chabadHouseId, enrollmentOptions, cancelToken) => {
    const response = await AuthClient.post(
      "Chat/chabadHouseEnrollments",
      { chabadHouseId, ...enrollmentOptions},
      { cancelToken },
    );
    return response.data.payload || {};
  },

  removeChatEnrollment: async (chabadHouseId, cancelToken) => {
    const response = await AuthClient.delete(
      `Chat/chabadHouseEnrollments?${queryString.stringify({ chabadHouseId })}`,
      { cancelToken },
    );
    return response.data.payload || {};
  },

  getShluchim: async (page, numResults, sortByOption, filters, cancelToken) => {
    const params = {
      page,
      results: numResults,
      sortByOption,
      text: filters.text,
      memberFilter: filters.memberFilter,
    };

    const response = await AuthClient.get(
      `Chat/manage/shluchim?${queryString.stringify(params)}`,
      { cancelToken },
    );
    return {
      shluchim: response.data.payload.results || [],
      totalShluchim: response.data.payload.numberOfRows || 0,
    };
  },

  getStudents: async (page, numResults, sortByOption, filters, cancelToken) => {
    const params = {
      page,
      results: numResults,
      sortByOption,
      text: filters.text,
      memberFilter: filters.memberFilter,
    };

    const response = await AuthClient.get(
      `Chat/manage/students?${queryString.stringify(params)}`,
      { cancelToken },
    );
    return {
      students: response.data.payload.results || [],
      totalStudents: response.data.payload.numberOfRows || 0,
    };
  },

  addChatMember: async (personId, cancelToken) => {
    const response = await AuthClient.post(
      `Chat/members/${personId}`,
      {},
      { cancelToken },
    );
    return response.data.payload || {};
  },

  removeChatMember: async (personId, cancelToken, setOptOut) => {
    const response = await AuthClient.delete(
      `Chat/members/${personId}`,
      { params: { setOptOut }, cancelToken },
    );
    return response.data.payload || {};
  },

  banChatMember: async (personId, cancelToken) => {
    const response = await AuthClient.post(
      `Chat/members/${personId}/ban`,
      {},
      { cancelToken },
    );
    return response.data.payload || {};
  },

  unbanChatMember: async (personId, cancelToken) => {
    const response = await AuthClient.post(
      `Chat/members/${personId}/unban`,
      {},
      { cancelToken },
    );
    return response.data.payload || {};
  },
};

export default ChatApi;
